/* eslint-disable @typescript-eslint/no-explicit-any */
import { Colors } from '@oy/uicore';
import { Padder, Text } from '@oy/uidesktop';
import {
  ProductFeatureIcon,
  ProductFeatureIconName,
  SystemIcon,
} from '@oy/uiicon';
import styles from './ShortcutSideModal.module.css';
import { ShortcutMenu } from './constant';

export const CardComponent = ({ menu }: { menu: ShortcutMenu }) => {
  return (
    <div onClick={menu.onClick} className={styles.container}>
      <div className={styles.menuIcon}>
        {menu.isFeatureIcon ? (
          <ProductFeatureIcon
            name={menu.iconName as ProductFeatureIconName}
            size={24}
            color={Colors.BLUE100}
          />
        ) : (
          <SystemIcon
            name={menu.iconName as any}
            size={24}
            color={Colors.BLUE100}
          />
        )}
      </div>
      <div>
        <Padder bottom={Padder.Size.XXXS}>
          <Text textStyle={Text.Style.BodyLgSemibold} color={Colors.BLACK100}>
            {menu.title}
          </Text>
        </Padder>
        <Text textStyle={Text.Style.BodySmRegular} color={Colors.BLACK60}>
          {menu.description}
        </Text>
      </div>
    </div>
  );
};
